module.exports = __webpack_public_path__ + "img/arrow_down_btn.6eae31a5.png";